import { FormBase } from 'core/components';

export default class GenerateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        const thisDate = new Date();
        const thisYear = new Date().getFullYear();
        const thisYearPlusFive = thisYear + 5;
        return {
            fields: [
                {
                    name: 'startDate',
                    label: 'SCHEDULE.GENERATE.START_DATE_LABEL',
                    placeholder: 'SCHEDULE.GENERATE.START_DATE_PLACEHOLDER',
                    rules: ['required','regex:/^(0[0-9]|[0-9]|(1)[0-2])/(0[0-9]|[0-9]|[1-2][0-9]|(3)[0-1])/((19|20)[\\d]{2})/g'],
                    value: `${thisDate.getMonth() + 1}/${thisDate.getDate()}/${thisYear}`             
                },
                {
                    name: 'endDate',
                    label: 'SCHEDULE.GENERATE.END_DATE_LABEL',
                    placeholder: 'SCHEDULE.GENERATE.END_DATE_PLACEHOLDER',                 
                    rules: ['required','regex:/^(0[0-9]|[0-9]|(1)[0-2])/(0[0-9]|[0-9]|[1-2][0-9]|(3)[0-1])/((19|20)[\\d]{2})/g'],
                    value: '12/31/' + thisYearPlusFive 
                },
                {
                    name: 'facilityId',
                    label: 'SCHEDULE.GENERATE.FACILITY_LABEL',
                    placeholder: 'SCHEDULE.GENERATE.FACILITY_PLACEHOLDER'                
                },
                {
                    name: 'overrideManuallyUpdated',
                    type: 'bool',
                    value: false
                }
            ],
        };
    }
}
